import drawSpline from "./drawSpline";
export function renderPanPreview(canvas, ctx, snapshot, offsetX, offsetY) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.shadowBlur = 0;
    ctx.fillStyle = "#000";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(snapshot, offsetX, offsetY);
}
export default function renderBoard(canvas, ctx, strokes, camera, activeStroke = null) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = "#000";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.setTransform(camera.zoom, 0, 0, camera.zoom, camera.panX, camera.panY);
    strokes.forEach((stroke) => drawSpline(ctx, stroke));
    if (activeStroke) {
        drawSpline(ctx, activeStroke);
    }
    ctx.restore();
}
